import EngineModule                     from '../EngineModule';
import { NS as PlannerFurnitureEditorNS } from '../components/viewer/planner/furniture/Editor/PlannerFurnitureEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'viewer-planner-furniture-editor',
	dependencies :     [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers : null,
	modulesBefore :    [ 'product-editor' ],
	modulesAfter :     [],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : null,
	generateComponentConfiguration() : PlannerFurnitureEditorNS.Configuration {
		const config = this.configuration;
		const allLinkSource : any = {};
		for(const [key,value] of Object.entries(config)){
			if(key.startsWith('linkSource')){
				if(key === 'linkSource-en'){
					if(!allLinkSource['siae']){
						allLinkSource['siae'] = {
							'en' : value
						};
						allLinkSource['confort'] = {
							'en' : value
						};
						allLinkSource['prestige'] = {
							'en' : value
						};
						allLinkSource['business'] = {
							'en' : value
						};
					}else{
						allLinkSource['siae']['en'] = value;
						allLinkSource['confort']['en'] = value;
						allLinkSource['prestige']['en'] = value;
						allLinkSource['business']['en'] = value;
					}
				}else if(key === 'linkSource-fr'){
					if(!allLinkSource['siae']){
						allLinkSource['siae'] = {
							'fr' : value
						};
						allLinkSource['confort'] = {
							'fr' : value
						};
						allLinkSource['prestige'] = {
							'fr' : value
						};
						allLinkSource['business'] = {
							'fr' : value
						};
					}else{
						allLinkSource['siae']['fr'] = value;
						allLinkSource['confort']['fr'] = value;
						allLinkSource['prestige']['fr'] = value;
						allLinkSource['business']['fr'] = value;
					}
				}else{
					const product = key.split('-')[1];
					const language = key.split('-')[2];
					if(language && product){
						if(!allLinkSource[product]){
							allLinkSource[product] = {
							};
							allLinkSource[product][language] = value;
						}else{
							allLinkSource[product][language] = value;
						}
					}
				}
			}
		}
		return {
			imgSource :  this.configuration.imgSource,
			linkSource : allLinkSource
		};
	}
});
